import React, { useState } from 'react';
import { Link } from 'react-scroll';
import FileSaver from "file-saver";


function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const downloadResume = () => {
   
    const resumeLink = "https://drive.google.com/file/d/152XopxoiCDbfNiVq5vQgwoSEUxM6RcHc/view?usp=sharing/fw20_0370-Martina-Varghese-Resume.pdf";
    
    window.open(resumeLink, "_blank");
   
    const resumeFile = "/fw20_0370-Martina-Varghese-Resume.pdf";
   
    FileSaver.saveAs(resumeFile, "fw20_0370-Martina-Varghese-Resume.pdf");
  };

  return (
    <nav
      className={`fixed w-full top-0 z-10b bg-indigo-900 text-white ${
        isOpen ? 'h-screen' : ''
      }`}
    >
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center justify-between ">
        <Link
          to="home"
          smooth={true}
          duration={500}
          className="cursor-pointer lg:text-5xl text-2xl font-signature ml-2 font-bold"
        >
          Martina Varghese
        </Link>
        <button
          className="md:hidden rounded-lg border border-gray-600 px-3 py-2 ml-auto"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            className="menu w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M1 4h18v2H1V4zm0 5h18v2H1V9zm0 5h18v2H1v-2z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <ul
          className={`${
            isOpen ? 'block' : 'hidden'
          } md:flex md:items-center w-full md:w-auto`}
        >
          <li>
            <Link
              to="home"
              smooth={true}
              duration={500}
              className="block mt-4 md:inline-block md:mt-0 text-white hover:text-gray-400 mr-6 cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="about"
              smooth={true}
              duration={500}
              className="block mt-4 md:inline-block md:mt-0 text-white hover:text-gray-400 mr-6 cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              About Me
            </Link>
          </li>
          <li>
            <Link
              to="skills"
              smooth={true}
              duration={500}
              className="block mt-4 md:inline-block md:mt-0 text-white hover:text-gray-400 mr-6 cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Skills
            </Link>
          </li>
          <li>
            <Link
              to="projects"
              smooth={true}
              duration={500}
              className="block mt-4 md:inline-block md:mt-0 text-white hover:text-gray-400 mr-6 cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              to="contact"
              smooth={true}
              duration={500}
              className="block mt-4 md:inline-block md:mt-0 text-white hover:text-gray-400 mr-6 cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>
          </li>
          <li>
            <a onClick={downloadResume} 
              className="block mt-4 md:inline-block md:mt-0 text-white hover:text-gray-400 mr-6 cursor-pointer "
              
            >
              Resume
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;































// import React, { useState } from "react";
// import { FaBars, FaTimes } from "react-icons/fa";
// import { Link } from "react-scroll";

// const NavBar = () => {
//   const [nav, setNav] = useState(false);

//   const links = [
//     {
//       id: 1,
//       link: "home",
//     },
//     {
//       id: 2,
//       link: "about me",
//     },
//     {
//       id: 3,
//       link: "project",
//     },
//     {
//       id: 4,
//       link: "skills",
//     },
//     {
//       id: 5,
//       link: "contact",
//     },
   
    

//   ];


//   return (
//     <div className="flex justify-between items-center w-full h-20 px-4 text-white bg-indigo-900 fixed">
//       <div>
//         <h1 className="lg:text-5xl font-signature ml-2">Martina Varghese</h1>
//       </div>

//       <ul className="hidden md:flex">
//         {links.map(({ id, link,href,download }) => (
//           <li
//             key={id}
//             className="px-4 cursor-pointer capitalize font-medium text-white hover:scale-105 duration-200 hover:border-b-4 border-indigo-500"
//           >
//             <Link to={link} smooth duration={500}>
//               {link}
             
//             </Link>
            
           
//           </li>
          
//         ))}
//         <a href="/Martina_Varghese_Resume.pdf" download  className="px-4 cursor-pointer capitalize font-medium text-white hover:scale-105 duration-200 hover:border-b-4 border-indigo-500"
// >
//               Resume 
//               </a>
        
      
        
//       </ul>

//       <div
//         onClick={() => setNav(!nav)}
//         className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden"
//       >
//         {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
//       </div>

//       {nav && (
//         <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500">
//           {links.map(({ id, link }) => (
//             <li
//               key={id}
//               className="px-4 cursor-pointer capitalize py-6 text-4xl"
//             >
//               <Link
//                 onClick={() => setNav(!nav)}
//                 to={link}
//                 smooth
//                 duration={500}
//               >
//                 {link}
//               </Link>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default NavBar;